import { render, staticRenderFns } from "./ExtractCategory.vue?vue&type=template&id=5481a3d5&"
import script from "./ExtractCategory.vue?vue&type=script&lang=ts&"
export * from "./ExtractCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports